import script from "./sf-table-headers.vue?vue&type=script&setup=true&lang=ts&generic=HD%20extends%20BaseHeader"
export * from "./sf-table-headers.vue?vue&type=script&setup=true&lang=ts&generic=HD%20extends%20BaseHeader"

const __exports__ = script;

export default __exports__